<ng-container *ngIf="isResponsive; else isdesktop">

    <div class="container" >
        <div class="card">
            <div class="content">
                <h1 class="title">Conoce más sobre la Reforma de Pensiones</h1>
                <p class="subtitle">Entérate de los cambios y beneficios que trae la reforma.</p>
                <p class="subtitle">Selecciona la información que deseas revisar:</p>
            </div>
        </div>
    </div>
    <!-- ESTRUCTURA CORREGIDA: El contenedor de botones es HERMANO del card, no un hijo. -->
    <div class="button-container" #headerReforma>
        <div class="button-wrapper">
            <div class="buttons">
                <button
                    *ngFor="let tab of tabs; let i = index"
                    class="button"
                    [class.active]="selectedTab === tab.key"
                    [attr.data-tab]="tab.key"
                    (click)="selectTab(tab.key)">
                    {{ tab.label }}
                </button>
            </div>
        </div>
    </div>

</ng-container>

<ng-template #isdesktop >
    <div class="container" #headerReforma>
        <div class="card">
            <div class="content">
                <h1 class="title">Conoce más sobre la Reforma de Pensiones</h1>
                <p class="subtitle">Entérate de los cambios y beneficios que trae la reforma.</p>
                <p class="subtitle">Selecciona la información que deseas revisar:</p>
            </div>
        </div>

        <!-- ESTRUCTURA CORREGIDA: El contenedor de botones es HERMANO del card, no un hijo. -->
        <div class="button-container">
            <div class="button-wrapper">
                <div class="buttons">
                  <button
                    *ngFor="let tab of tabs; let i = index"
                    class="button"
                    [class.active]="selectedTab === tab.key"
                    [attr.data-tab]="tab.key"
                    (click)="selectTab(tab.key)">
                    {{ tab.label }}
                </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>